import type {
  CareplanDataModel,
  CareplanMeta,
  CareplanProductRole,
} from "@/domains/careplan/models/types";

export const createCareplanModel = (careplan: CareplanDataModel & Partial<CareplanMeta>) => {
  return {
    ...careplan,
    getProductRoleChanges: (role: CareplanProductRole) => {
      if (careplan.isInitial) {
        return [];
      }

      return (
        careplan.changes?.filter((change) => {
          return change.role === role;
        }) ?? []
      );
    },
  };
};
